import util from '@/libs/util.js';
export default {
  namespaced: true,
  mutations: {
    /**
     * @description 显示版本信息
     * @param {Object} state state
     */
    versionShow: function versionShow() {
      util.log.capsule('U8SDK', "V-".concat(process.env.VUE_APP_VERSION));
      console.log('---------------------------------');
      console.log('官方网站：  http://www.u8sdk.com');
      console.log('技术博客：  http://www.uustory.com');
      console.log('在线文档  http://wiki.u8sdk.com');
      console.log('视频教程(百度传课已停运，迁移至B站：)：  \nhttps://space.bilibili.com/15265144');
      console.log('---------------------------------');
      console.log('采用Springboot+Vue+Element 进行开发');
      console.log('本后台基于开源模板D2Admin： \nhttps://github.com/d2-projects/d2-admin');
    }
  }
};